module.exports = __webpack_public_path__ + "static/media/tom_hardy.1e97e2b2.jpg";